import { useMemo } from "react";
import { WorkflowVisualizationContextMenu } from "@containers/common/workflow-visualization-container/workflow-visualization-policy-configs-container/workflow-visualization-context-menu/workflow-visualization-context-menu";
import {
    FormattedRpServiceConfiguration,
    FormattedRpServiceConfigurationPolicyConfigDecision
} from "@idw-types/data/rp-service-configuration";
import { resources } from "@constants/hardcoded-strings";
import { Edge } from "reactflow";

type WorkflowVisualizationPolicyDecisionContextMenuProps = {
    top: number;
    left: number;
    right: number;
    bottom: number;
    edge: Edge<{
        label: string;
        description: string;
        sourceServiceId: string;
        isDefaultAction: boolean;
        decisionUuids: Array<string>;
    }>;
    menuRef: React.MutableRefObject<any>;
    rpServices: Array<FormattedRpServiceConfiguration>;
    onPaneClick: () => void;
    onClickOpenPolicyDecisionDetails: (
        policyDecisions: Array<FormattedRpServiceConfigurationPolicyConfigDecision>,
        rpService: FormattedRpServiceConfiguration,
        isDefaultAction: boolean
    ) => void;
};

export const WorkflowVisualizationPolicyDecisionContextMenu = (props: WorkflowVisualizationPolicyDecisionContextMenuProps) => {
    const {
        top,
        left,
        right,
        bottom,
        edge,
        menuRef,
        rpServices,
        onPaneClick,
        onClickOpenPolicyDecisionDetails
    } = props;

    const resource = resources.common.containers.workflowVisualization.sections.menu;

    const onClickOpenDetails = () => {
        let decisions: Array<FormattedRpServiceConfigurationPolicyConfigDecision> = [];
        let service = null;
        let isDefaultAction = false;
        console.log(edge);
        const decisionUuids = edge.data.decisionUuids;

        const matchingService = rpServices.find(service => service.id === edge.data.sourceServiceId);

        if (matchingService) {
            service = matchingService;

            if (edge.data.isDefaultAction) {
                isDefaultAction = true;
            } else if (edge.data.decisionUuids.length > 0 && matchingService?.policyConfig?.decisions) {
                decisions = matchingService.policyConfig.decisions.filter(decision => decisionUuids.includes(decision.uuid));
            }
        }

        onClickOpenPolicyDecisionDetails(decisions, service, isDefaultAction);
    };

    const menuActions = useMemo(() => {
        const actions = [];
        if (edge.id) {
            actions.push({
                actionId: "open-details",
                label: resource.viewPolicyDecision.label,
                action: onClickOpenDetails
            });
        }

        return actions;
    }, [edge.id, left, right, top, bottom]);

    return (
        <WorkflowVisualizationContextMenu
            onClick={onPaneClick}
            id={edge.id}
            top={top}
            left={left}
            right={right}
            bottom={bottom}
            menuRef={menuRef}
            actions={menuActions}
        />
    );
};